module.exports = __webpack_public_path__ + "img/broker.d58444cf.svg";